import React from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  Stack,
  // Import alpha for color manipulation
} from "@mui/material";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { FaCheckCircle, FaLock, FaMoneyBillWave, FaRocket,  } from "react-icons/fa";

import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const CTAHomeSection = () => {

  const { token } = useSelector((state) => state.auth);
  const isLoggedIn = Boolean(token);

  return (
    <Box
      sx={{
        py: { xs: 5, md: 10 },
        // background: `
        //     linear-gradient(135deg, rgba(244, 197, 66, 0.1) 0%, rgba(254, 253, 251, 1) 50%, rgba(244, 197, 66, 0.1) 100%)
        //   `,
        background:'#fff',
        textAlign: "center",
        position: "relative",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "3rem", md: "4.5rem" },
            fontWeight: 900,
            mb: 4,
            color: "#2D3A27",
            letterSpacing: "-2px",
          }}
        >
          Ready to Transform Your
          <Box
            component="span"
            sx={{
              background: "linear-gradient(135deg, #F4C542 0%, #E6B73A 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              display: "block",
            }}
          >
            Scrap Business?
          </Box>
        </Typography>
        <Typography
          variant="h4"
          sx={{
            color: "rgba(45, 58, 39, 0.8)",
            mb: 8,
            maxWidth: "800px",
            mx: "auto",
            lineHeight: 1.6,
            fontSize: { xs: "1.5rem", md: "2rem" },
          }}
        >
          Join thousands of traders who trust ScrapTrade for secure,
          transparent, and profitable scrap trading.
        </Typography>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={4}
          justifyContent="center"
          sx={{ mb: 8 }}
        >
          <Button
            component={Link}
            to={isLoggedIn ? "/dashboard" : "/register"} // 👈 condition here
            variant="contained"
            size="large"
            endIcon={<ArrowForwardIcon />}
            sx={{
              background: "linear-gradient(135deg, #F4C542 0%, #E6B73A 100%)",
              color: "#2D3A27",
              borderRadius: "20px",
              px: 5,
              py: 2,
              fontSize: "1.4rem",
              fontWeight: 700,
              textTransform: "none",
              boxShadow: "0 20px 40px rgba(244, 197, 66, 0.4)",
              minWidth: "250px",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 25px 50px rgba(244, 197, 66, 0.6)",
              },
            }}
          >
            Start Trading Today
          </Button>
          <Button
           component={Link}
            to="/contact-us" // 👈 Link to contact page
            variant="outlined"
            size="large"
            sx={{
              borderColor: "#F4C542",
              color: "#F4C542",
              borderRadius: "20px",
              px: 5,
              py: 2,
              fontSize: "1.4rem",
              fontWeight: 700,
              textTransform: "none",
              borderWidth: "3px",
              minWidth: "250px",
              "&:hover": {
                borderColor: "#E6B73A",
                background: "rgba(244, 197, 66, 0.1)",
                borderWidth: "3px",
              },
            }}
          >
            Contact Sales
          </Button>
        </Stack>
        
        <Typography
          variant="h6"
          sx={{
            color: "rgba(45, 58, 39, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            flexWrap: "wrap",
            fontSize: "1.1rem",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1,padding:2 }}>
            <FaCheckCircle color="#2D3A27" /> Free to join
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1,padding:2 }}>
            <FaRocket color="#2D3A27" /> Instant verification
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1,padding:2 }}>
            <FaMoneyBillWave color="#2D3A27" /> Transparent pricing
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1,padding:2 }}>
            <FaLock color="#2D3A27" /> Secure payments
          </Box>
        </Typography>
      </Container>
    </Box>
  );
};

export default CTAHomeSection;
